import React from 'react';
import { Form, InputNumber } from 'antd';
import { NamePath } from 'rc-field-form/lib/interface';

type NumberInputProps = {
  name: NamePath;
  label: string;
  value?: number;
  required?: boolean;
  disabled?: boolean;
  onChange?: (value: number) => void;
  hidden?: boolean;
  min?: number;
  max?: number;
};

export function NumberInput(props: NumberInputProps) {
  const handleChange = (value: number) => {
    if (props.onChange) {
      props.onChange(value);
    }
  };
  return (
    <>
      <Form.Item name={props.name} label={props.label} rules={[{ required: props.required, message: `${props.label} is required` }]} hidden={props.hidden}>
        <InputNumber
          type="number"
          style={{ width: '100%' }}
          value={props.value}
          onChange={(value) => {
            handleChange(value);
          }}
          disabled={props.disabled}
          min={props.min}
          max={props.max}
        />
      </Form.Item>
    </>
  );
}
